import { observer } from 'mobx-react'

import { tJosa } from '~/@app/i18n'
import { useStudentAppMediaQuery } from '~/@common/hooks/useMediaQuery'
import { colors } from '~/@common/styles'
import { Icon } from '~/@common/ui/Icon/Icon'

import type { LectureGroup as _LectureGroup } from '../@service/Lecture.service'
import { LectureListSkeleton } from '../LectureListSkeleton'
import { S } from './LectureGroup.style'
import LectureTable from './LectureTable.widget'
import MobileLectureGroupList from './MobileLectureGroupList.widget'

type Props = {
  isFetching: boolean
  lectureGroups?: _LectureGroup[]
}

const LectureGroupList = ({ lectureGroups, isFetching }: Props) => {
  const { isMobile } = useStudentAppMediaQuery()

  if (isFetching) {
    return <LectureListSkeleton />
  }

  if (!lectureGroups) return null

  if (lectureGroups.length === 0) {
    return (
      <div css={S.Empty}>
        <div className="circle">
          <Icon name="icon_video" size={24} color={colors.white} />
        </div>
        <p>{tJosa('강의', '이/가')} 준비되지 않았어요</p>
      </div>
    )
  }

  if (isMobile) {
    return <MobileLectureGroupList lectureGroups={lectureGroups} />
  }

  return <LectureTable lectureGroups={lectureGroups} />
}

export default observer(LectureGroupList)
